import SelectableVehicles from './SelectableVehicles';
export default SelectableVehicles;



// WEBPACK FOOTER //
// ./src/components/App/VehiclesManagerDashboard/SelectableVehicles/index.js